<template>
  <div class="pl-6">
    <div class="text-sm font-semibold text-white">
      Blog
    </div>

    <nav class="mt-8">
      <ul class="space-y-3">
        <LinkGroup
          :parent="{
            text: 'Motion Array',
            link: '/learn/motion-array/',
            target: '_blank'
          }"
          :children="[
            {
              text: 'Tutorials',
              link: '/learn/motion-array/tutorials/',
              target: '_blank'
            },
            {
              text: 'Resources',
              link: '/learn/motion-array/resources/',
              target: '_blank'
            },
            {
              text: 'News',
              link: '/learn/motion-array/news/',
              target: '_blank'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'After Effects',
            link: '/learn/after-effects/',
            target: '_blank'
          }"
          :children="[
            {
              text: 'Tutorials',
              link: '/learn/after-effects/tutorials/',
              target: '_blank'
            },
            {
              text: 'Resources',
              link: '/learn/after-effects/resources/',
              target: '_blank'
            },
            {
              text: 'News',
              link: '/learn/after-effects/news/',
              target: '_blank'
            },
            {
              text: 'Troubleshooting',
              link: '/learn/after-effects/troubleshooting/',
              target: '_blank'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Premiere Pro',
            link: '/learn/premiere-pro/',
            target: '_blank'
          }"
          :children="[
            {
              text: 'Tutorials',
              link: '/learn/premiere-pro/tutorials/',
              target: '_blank'
            },
            {
              text: 'Resources',
              link: '/learn/premiere-pro/resources/',
              target: '_blank'
            },
            {
              text: 'News',
              link: '/learn/premiere-pro/news/',
              target: '_blank'
            },
            {
              text: 'Troubleshooting',
              link: '/learn/premiere-pro/troubleshooting/',
              target: '_blank'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'DaVinci Resolve',
            link: '/learn/davinci-resolve/',
            target: '_blank'
          }"
          :children="[
            {
              text: 'Tutorials',
              link: '/learn/davinci-resolve/tutorials/',
              target: '_blank'
            },
            {
              text: 'Resources',
              link: '/learn/davinci-resolve/resources/',
              target: '_blank'
            },
            {
              text: 'News',
              link: '/learn/davinci-resolve/news/',
              target: '_blank'
            },
            {
              text: 'Troubleshooting',
              link: '/learn/davinci-resolve/troubleshooting/',
              target: '_blank'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Final Cut Pro',
            link: '/learn/final-cut-pro/',
            target: '_blank'
          }"
          :children="[
            {
              text: 'Tutorials',
              link: '/learn/final-cut-pro/tutorials/',
              target: '_blank'
            },
            {
              text: 'Resources',
              link: '/learn/final-cut-pro/resources/',
              target: '_blank'
            },
            {
              text: 'News',
              link: '/learn/final-cut-pro/news/',
              target: '_blank'
            },
            {
              text: 'Troubleshooting',
              link: '/learn/final-cut-pro/troubleshooting/',
              target: '_blank'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Filmmaking',
            link: '/learn/filmmaking/',
            target: '_blank'
          }"
          :children="[
            {
              text: 'Tutorials',
              link: '/learn/filmmaking/tutorials/',
              target: '_blank'
            },
            {
              text: 'Resources',
              link: '/learn/filmmaking/resources/',
              target: '_blank'
            },
            {
              text: 'News',
              link: '/learn/filmmaking/news/',
              target: '_blank'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Motion Design',
            link: '/learn/motion-design/',
            target: '_blank'
          }"
          :children="[
            {
              text: 'Tutorials',
              link: '/learn/motion-design/tutorials/',
              target: '_blank'
            },
            {
              text: 'Resources',
              link: '/learn/motion-design/resources/',
              target: '_blank'
            },
            {
              text: 'News',
              link: '/learn/motion-design/news/',
              target: '_blank'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Post Production',
            link: '/learn/post-production/',
            target: '_blank'
          }"
          :children="[
            {
              text: 'Tutorials',
              link: '/learn/post-production/tutorials/',
              target: '_blank'
            },
            {
              text: 'Resources',
              link: '/learn/post-production/resources/',
              target: '_blank'
            },
            {
              text: 'News',
              link: '/learn/post-production/news/',
              target: '_blank'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Music',
            link: '/learn/royalty-free-music/',
            target: '_blank'
          }"
          :children="[
            {
              text: 'Tutorials',
              link: '/learn/royalty-free-music/tutorials/',
              target: '_blank'
            },
            {
              text: 'Resources',
              link: '/learn/royalty-free-music/resources/',
              target: '_blank'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Video Effects',
            link: '/learn/video-effects/',
            target: '_blank'
          }"
          :children="[
            {
              text: 'Tutorials',
              link: '/learn/video-effects/tutorials/',
              target: '_blank'
            },
            {
              text: 'Resources',
              link: '/learn/video-effects/resources/',
              target: '_blank'
            },
          ]"
        />
      </ul>
    </nav>
  </div>
</template>

<script>
import LinkGroup from './link-group';

export default {
  components: {
    LinkGroup,
  },
};
</script>
